import * as React from 'react';
import styled from 'styled-components';
import { CTA } from '@volkswagen-onehub/components-core';

interface ClusterButtonProps {
  active: boolean;
  icon: React.JSX.Element;
  ariaLabel: string;
  handleClick: () => void;
}

const CTAWrapper = styled.div<{ active: boolean }>`
  button {
    color: ${({ theme, active }) => active && theme.colors.button.tertiary.active};
  }
`;

export const ClusterButton = ({
  active,
  icon,
  ariaLabel,
  handleClick,
  ...rest
}: ClusterButtonProps): JSX.Element => {
  return (
    <CTAWrapper active={active}>
      <CTA
        aria-label={ariaLabel}
        onClick={handleClick}
        {...rest}
        icon={icon}
        tag="button"
        size="small"
        emphasis="tertiary"
      />
    </CTAWrapper>
  );
};
